import { observer } from "mobx-react";
import React from "react";
import TimelinePageStore from "pages/TimelinePage/store/TimelinePageStore";
import { Grid, Paper } from "@mui/material";

interface Props {
  pageStore: TimelinePageStore;
}
function TimelineEmoticonView(props: Props) {
  const { pageStore } = props;

  const handleMouseEnter = (index: number) => {
    let filterEmojiList = pageStore.emogiList.filter((emoji, idx) => {
      if (index === idx) {
        emoji.isHover = true;
      }
      return emoji;
    });
    pageStore.setEmogiList(filterEmojiList);
  };

  const handleMouseLeave = (index: number) => {
    let filterEmojiList = pageStore.emogiList.filter((emoji, idx) => {
      if (index === idx) {
        emoji.isHover = false;
      }
      return emoji;
    });
    pageStore.setEmogiList(filterEmojiList);
  };

  const renderEmoticon = () => {
    // console.log('emoji1111>'+pageStore.maxEmojiCount, pageStore.minEmojiCount);
    const ratio = (110 * pageStore.minEmojiCount) / pageStore.maxEmojiCount;
    // console.log(ratio);
    return (
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 6, sm: 8, md: 12 }}
      >
        {pageStore.emogiList.map((emoji, index) => {
          // console.log('emoji2222>'+emoji.count, emoji);
          if (emoji.count !== 0) {
            return (
              <Grid
                item
                xs={2}
                sm={4}
                md={4}
                style={{ paddingTop: 0, paddingLeft: 0 }}
              >
                <Paper
                  key={index}
                  style={{
                    maxWidth: 110,
                    maxHeight: 110,
                    width: emoji.count * ratio,
                    height: emoji.count * ratio,
                    fontSize: `${(emoji.count * ratio) / 2}px`,
                    display: "inline-flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: emoji.isHover
                      ? "rgba(54, 188, 153, 0.5)"
                      : "#FFFFFF",
                    borderRadius: "50%",
                    marginTop: "30px",
                    marginLeft: "6px",
                    color: emoji.isHover ? "white" : "black",
                    fontWeight: 700,
                  }}
                  onMouseEnter={() => handleMouseEnter(index)}
                  onMouseLeave={() => handleMouseLeave(index)}
                >
                  <Grid>
                    {emoji.isHover ? (
                      <>
                        {((emoji.count / pageStore.totalEmoji) * 100).toFixed(
                          0
                        )}
                        %
                      </>
                    ) : (
                      emoji.emoji
                    )}
                  </Grid>
                </Paper>
              </Grid>
            );
          }
        })}
      </Grid>
    );

  };

  return (
    <Grid
      style={{
        padding: "24px",
        paddingBottom: "0px",
        minWidth: "360px",
        maxHeight: "360px",
        background:
          "radial-gradient(50% 50% at 50% 50%, #F7F7F7 0%, #FFFFFF 100%)",
      }}
      textAlign={"center"}
    >
      {renderEmoticon()}
    </Grid>
  );
}

export default observer(TimelineEmoticonView);
